module.exports = __webpack_public_path__ + "img/IMAGE 1.70da938c.png";